module.exports = __webpack_public_path__ + "static/media/404-bg.97006807.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/404-bg.png
// module id = 2950
// module chunks = 23